<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - P-Angebot</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--producer-quote">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <span class="subtitle-1">Produzentenangebot auswählen</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-9">
                            <div class="row">
                                <div class="col">
                                    <form @submit.prevent="submit">
                                        <div class="row"  v-if="this.$page.props.env !== 'production'">
                                            <div class="col">
                                                <card class="warning">
                                                    <card-content>
                                                        <strong>Enticklermodus aktiv:</strong> Produzentenangebote können vor Ende der Bietrunde ausgewählt werden, bei Auswahl wird die zugehörige Bietrunde automatisch beendet.
                                                    </card-content>
                                                </card>
                                            </div>
                                        </div>
                                        <div class="row">

                                            <div class="col">
                                                <card>
                                                    <card-header>
                                                        <card-overline>
                                                            Produzentenangebote - Editierbar bis: {{ bidRoundEndings }}
                                                        </card-overline>
                                                    </card-header>
                                                    <card-content>
                                                        <table class="table table--stripped table--card table--td-top">
                                                            <thead>
                                                            <tr>
                                                                <th class="small"></th>
                                                                <th>P-Nr.</th>
                                                                <th>Firma</th>
                                                                <th>Land</th>
                                                                <th class="text-right">Stückzahl</th>
                                                                <th class="text-right">Preis Pro St.</th>
                                                                <th class="text-right">Nettopreis</th>
                                                                <th class="text-right">Lieferzeit <span><span>vorgeschlagen</span></span></th>
                                                                <th class="text-right">Lieferzeit <span><span>Produzent</span></span></th>
                                                                <th>Ranking</th>
                                                                <th>Aktive Aufträge</th>
                                                                <th>Aktive Reklamationen</th>
                                                                <th></th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr v-for="producerOffer in producerOffers" :key="producerOffer.index">
                                                                <td>
                                                                    <form-radio :disabled="!producerOffer.useable || ! clientUserIsChecked" :id="'producerOffer'+producerOffer.id" name="producer_offer" v-model:checked="form.producer_offer" :value="producerOffer.id"></form-radio>
                                                                </td>
                                                                <td>{{ producerOffer.producer_user.prod_no }}</td>
                                                                <td>{{ producerOffer.producer_user.company }}</td>
                                                                <td>{{ producerOffer.producer_user.producer_country.country_name }}</td>
                                                                <td v-html="producerOffer.lot_qty" class="text-right"></td>
                                                                <td v-html="producerOffer.price_per_unit" class="text-right"></td>
                                                                <td v-html="producerOffer.lot_offer" class="text-right"></td>
                                                                <td class="text-right">{{ producerOffer.delivery_days_for_producer }}</td>
                                                                <td v-html="producerOffer.lot_delivery" class="text-right"></td>
                                                                <td>{{ producerOffer.producer_user.ranking }}</td>
                                                                <td>{{ producerOffer.producer_user.total_active_offers }}</td>
                                                                <td>{{ producerOffer.producer_user.active_complaints }}</td>
                                                                <td class="va-middle">
                                                                    <form-button type="button" icon="arrow-right" dense="true" :disabled="clientOfferIsNotSend" @click="createAlternateOffer($event, producerOffer)" v-if="producerOffer.producer_user.id !== askForQuote?.client_offers?.[0]?.producer_user.id"/>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </card-content>
                                                </card>
                                            </div>
                                        </div>
                                        <div class="row row--sticky" v-sticky>
                                            <div class="col">
                                                <form-actions align="right">
                                                    <form-button type="button" icon="delete-disabled" @click="rejectDialog = !rejectDialog" :disabled="disabledTab">Anfrage ablehnen</form-button>
                                                    <form-button type="button" color="error" icon="trash-delete-bin-2" disabled="disabled">Angebot löschen</form-button>
                                                    <form-button color="secondary" icon="button-arrow-right-circle" :disabled="! clientOfferIsNotSend || disabledTab || ! hasProducerOffers  || ! clientUserIsChecked || form.processing" :class="{'btn--processing': form.processing}">Angebot verwenden</form-button>
                                                </form-actions>
                                            </div>
                                        </div>
                                    </form>
                                    <client-quote-reject :askForQuote="askForQuote" v-if="rejectDialog" @closeDialog="rejectDialog = false" reject="offer" />
                                </div>
                            </div>
                            <div class="row" v-if="askForQuote.client_offers.length > 0">
                                <div class="col">
                                    <card>
                                        <card-header>
                                            <card-overline>
                                                Übersicht erhaltene Angebote
                                            </card-overline>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--stripped table--card table--td-top">
                                                <thead>
                                                    <tr>
                                                        <th>P-Nr.</th>
                                                        <th class="text-right">Stückzahl</th>
                                                        <th class="text-right">P-Preis</th>
                                                        <th class="text-right">Angebotspreis</th>
                                                        <th class="text-right">Lieferzeit <span><span>Anfrage</span></span></th>
                                                        <th class="text-right">Lieferzeit <span><span>Produzent</span></span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="producerOffer in producerOffers" :key="producerOffer.index">
                                                        <td>{{ producerOffer.producer_user.prod_no }}</td>
                                                        <td v-html="producerOffer.lot_qty" class="text-right"></td>
                                                        <td v-html="producerOffer.lot_offer" class="text-right"></td>
                                                        <td v-html="producerOffer.lot_client_offer" class="text-right"></td>
                                                        <td class="text-right">{{ producerOffer.delivery_days_for_producer_client }}</td>
                                                        <td v-html="producerOffer.lot_delivery_client" class="text-right"></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <card>
                                <card-header>
                                    <card-overline>
                                        Details zur Aussschreibung
                                    </card-overline>
                                </card-header>
                                <card-content>
                                    <description-group>
                                        <description-element :caption="countBidRounds" title="Ausschreibungen"  />
                                        <description-element :caption="countBidRoundMembers" title="verschickte Anfragen"  />
                                        <description-element :caption="countBidRoundOffers" title="erhaltene Angebote"  />
                                    </description-group>
                                </card-content>
                            </card>
                            <card>
                                <card-header>
                                    <card-overline>Kundenkommentar</card-overline>
                                </card-header>
                                <card-content>
                                    <p>{{ clientComment }}</p>
                                </card-content>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import FormRadio from '@partfactory/Shared/Form/FormRadio';
import {useForm} from '@inertiajs/vue3';
import ClientQuoteReject from '@partfactory/Pages/Admin/AskForQuote/Modals/ClientQuoteReject';

export default {
    name: 'ProducerOffer',
    components: {
        ClientQuoteReject,
        FormRadio,
        DescriptionElement,
        DescriptionGroup,
        FormButton,
        FormActions,
        CardContent,
        CardOverline,
        CardHeader,
        Card,
        AskForQuoteHeader, AppAdminLayout
    },
    props: {
        askForQuote: Object,
    },
    data() {
        let rejectDialog = false;
        const form = useForm({
            producer_offer: null,
        });
        return {form, rejectDialog};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.producer-offer.post', {'askForQuote': this.askForQuote.id}));
        },
        createAlternateOffer($event, selectedAlternateOffer) {
            this.$inertia.post(this.$$route('ask-for-quote.producer-offer.replicate', {'askForQuote': this.askForQuote.id, 'bidRoundMember': selectedAlternateOffer.id}));
        },
    },
    computed: {
        clientOfferIsNotSend() {
            // TODO, sollte auch serverseitig geprüft werden
            const clientOffers = this.askForQuote.client_offers.filter(clientOffer => clientOffer.client_offer_send);
            return ! clientOffers.length > 0;
        },
        bidRoundEndings() {
            let bidRoundEnds = [];
            this.askForQuote.bid_rounds.forEach((bidRound, index) => {
                bidRoundEnds.push('B'+(index+1)+' '+this.$dateTime(bidRound.ending_at));
            });
            return bidRoundEnds.join(', ');
        },
        countBidRounds() {
            return this.askForQuote.bid_rounds.length;
        },
        countBidRoundMembers() {
            let count = 0;
            this.askForQuote.bid_rounds.forEach(bidRound => {
                count += bidRound.bid_round_members.length;
            });

            return count;
        },
        countBidRoundOffers() {
            let count = 0;
            this.askForQuote.bid_rounds.forEach(bidRound => {
                count += bidRound.bid_round_members.filter(bid_round_members => bid_round_members.offer_given === true).length;
            });

            return count;
        },
        producerOffers() {

            let producerOffers = [];

            this.askForQuote.bid_rounds.forEach(bidRound => {

                const bidRoundMembers = bidRound.bid_round_members.filter(bid_round_members => { return bid_round_members.offer_given === true; });

                bidRoundMembers.map( (producerOffer) => {

                    if (this.$page.props.env === 'production' && new Date(bidRound.ending_at) < new Date() && !producerOffer.rejected && new Date(producerOffer.offer_valid_until) > new Date() )
                        producerOffer.useable = true;
                    else if (this.$page.props.env !== 'production' && !producerOffer.rejected && new Date(producerOffer.offer_valid_until) > new Date() )
                        producerOffer.useable = true;
                    else
                        producerOffer.useable = false;

                    let lotQty = [];
                    lotQty.push(bidRound.lotqty_1, bidRound.lotqty_2, bidRound.lotqty_3, bidRound.lotqty_4);
                    producerOffer.lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                    let lotOffer = [];
                    lotOffer.push(producerOffer.lot_offer_1, producerOffer.lot_offer_2, producerOffer.lot_offer_3, producerOffer.lot_offer_4);
                    producerOffer.lot_offer = lotOffer.map(lot => {
                        return lot ? this.$currency((Math.round(lot * 100) / 100).toFixed(2)) : '';
                    }).filter(lot => lot !== '').join('<br>');

                    producerOffer.lot_client_offer = lotOffer.map((lot, index) => {
                        lot = lot ? lot + this.clientOfferMargins[index] : '';
                        return lot ? this.$currency((Math.round(lot * 100) / 100).toFixed(2)) : '';
                    }).filter(lot => lot !== '').join('<br>');

                    let pricePerUnit = [];
                    pricePerUnit.push(
                        (producerOffer.lot_offer_1 / bidRound.lotqty_1),
                        (producerOffer.lot_offer_2 / bidRound.lotqty_2),
                        (producerOffer.lot_offer_3 / bidRound.lotqty_3),
                        (producerOffer.lot_offer_4 / bidRound.lotqty_4),
                    );
                    producerOffer.price_per_unit = pricePerUnit.map(lot => {
                        return lot ? this.$currency(lot.toFixed(2)) : '';
                    }).filter(lot => lot !== '').join('<br>');

                    producerOffer.delivery_days_for_producer = bidRound.delivery_days_for_producer + ' Tage';

                    producerOffer.delivery_days_for_producer_client = (bidRound.delivery_days_for_producer + this.$page.props.factors.delivery_time_part_client ) + ' Tage';

                    let lotDelivery = [];
                    lotDelivery.push(producerOffer.lot_delivery_1, producerOffer.lot_delivery_2, producerOffer.lot_delivery_3, producerOffer.lot_delivery_4);
                    producerOffer.lot_delivery = lotDelivery.filter(lot => lot !== null).map(lot => {
                        return lot + ' Tage';
                    }).join('<br>');

                    producerOffer.lot_delivery_client = lotDelivery.filter(lot => lot !== null).map(lot => {
                        return (lot + this.$page.props.factors.delivery_time_part_client) + ' Tage';
                    }).join('<br>');


                });

                producerOffers.push(...bidRoundMembers);
            });

            return producerOffers;
        },
        clientOfferMargins() {
            let margins = [];
            this.askForQuote.client_offers.map(clientOffer => {
                margins.push(clientOffer.net_price - clientOffer.producer_price);
            });
            return margins;
        },
        clientComment() {
            return this.askForQuote.client_user.comment;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 5);
        },
        hasProducerOffers() {
            return this.producerOffers.length > 0;
        },
        clientUserIsChecked() {
            return this.askForQuote.client_user.is_checked;
        },
    },
};
</script>
